import { app } from '../../../../../app';
import { Controller } from './manage-shared-note.controller';

app.component('companySharingCenterSharedNoteManage', {
	bindings: {
		companyId:'<',
		sharedAccount:'<'
	},
    controller: Controller,
    templateUrl: require('./manage-shared-note.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-notes/manage/manage-shared-note.component.js